<template>
  <section id="main-wrap" class="pure-g">  
    <div id="main-col" class="pure-u-3-5">

      <div class="how-to-grapevine-wrap" v-if="howToGrapevineActivated">
        <div class="container">
          <a href="#" v-on:click.stop.prevent="howToGrapevineClose" class="modal-close"><i class="fal fa-times"></i></a>

          <div class="title-wrap">
            <h2>Hi, welcome to grapevine.</h2>
            <div class="tabs-select">
              <a href="#" v-on:click.stop.prevent="modalTabSwitch('video')" class="active" data-id="video">Grapevine in a Grape</a>
              <a href="#" v-on:click.stop.prevent="modalTabSwitch('image')" data-id="image">Site Map</a>
            </div>
          </div>
          <div class="tab-wrap">
            <div class="tab" data-tab="video">
              <p>Grapevine is a site filled with ‘<strong>grapes</strong>’ – passages from books of between 100 and 550 words.</p>
              <p>The point of grapevine is to be able to find, remember and re-read that great nugget you discovered last week or last year.</p>
              <p>By reading and adding grapes, you can share passages, stumble upon the best-expressed writing, and, over time, build up your own <strong>notebook of knowledge</strong>.</p>
              <div class="divide"></div>
              <p>To add grapes, rate them, or make grapevines, you’ll need to <a href="/account">create an account</a>.</p>
              <div class="divide"></div>
              <p><a href="/add">Adding grapes</a> takes <strong>less than a minute</strong>.</p>
              <div class="video-wrap">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/4wv5_Nyc7-g" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
              <p>a) choose a book passage you wish to grape and take a photo of the page(s),</p>
              <p>b) find the relevant book using the Source and/or Author boxes <a href="/add">here</a>,</p>
              <p>c) upload the photo(s) – this automatically converts to digital text,</p>
              <p>d) give the grape a title, and an optional short note (recommended for fiction).</p>
              <div class="divide"></div>
              <p>If the page photo is good (flat, sharp &amp; shadowless), the digital text shouldn’t need much correcting, if any.</p>
              <p>The text will convert as one big block, if you wouldn’t mind adding back in the original paragraphs.</p>
              <p>You can also add ‘<strong>reader paragraphs</strong>’ by using the > symbol, to make that long Dostoyevsky-ish passage more readable.</p>
              <div class="divide"></div>
              <p>You can also, for clarity, make occasional <strong>omissions</strong> to the text. Instead of an ellipsis, we mark these with the + symbol.</p>
              <p>Omissions allow you to string together a grape that runs over a few pages, when the writer may have digressed.</p>
              <p>Grapes are all uploaded publicly, so they need to be accurate and, if any omissions have been made, fair to the writer’s meaning.</p>
              <div class="divide"></div>
              <p>Once logged in, you can make ‘<strong>grapevines</strong>’. These are in the left-hand sidebar.</p>
              <p>Grapevines are like playlists, where you gather together grapes under a theme (you can add anyone’s grapes to your vines).</p>
              <p>You can <strong>find other readers</strong> in the right-hand sidebar – you can view their grapes and send them a message. (Press enter to see all readers; find me under ‘grapevine’.)</p>
              <div class="divide"></div>
              <p>At the top of the page, you can find grapes if you search by theme, place, author, etc. We have 1600+ grapes so far.</p>
              <p>Finally, grapes are all shown in preview form: just click on the text to view in full.</p>
              <p>Happy grape picking and grape reading.</p>
            </div>
            <div class="tab" data-tab="image">
              <img src="../assets/img/howtograpevine.png" />
            </div>
          </div>
        </div>
      </div>

      <router-link :to="addGrapeLink" class="pure-button hidden-mobile" id="add-grape-button"><svg enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Upload"><path d="M31,21.996c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.443,31.552,21.996,31,21.996z" fill="#fff"/><path d="M9.731,8.602l5.275-5.2v19.593c0,0.552,0.452,1,1.01,1c0.558,0,1.01-0.448,1.01-1V3.402l5.275,5.2   c0.394,0.391,1.034,0.391,1.428,0s0.395-1.024,0-1.414L16.73,0.289c-0.39-0.387-1.046-0.383-1.429,0L8.303,7.188   c-0.395,0.391-0.394,1.024,0,1.414C8.697,8.993,9.337,8.993,9.731,8.602z" fill="#fff"/></g><g/><g/><g/><g/><g/><g/></svg>Add grapes</router-link>
      <router-link to="/add" class="pure-button visible-mobile" id="add-grape-button">Add a grape</router-link>
      <a class="pure-button hidden-mobile" id="browse-grapevines-button" href="#" v-on:click.stop.prevent="howToGrapevine()"><svg enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Download"><path d="M31,22c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.448,31.552,22,31,22z" fill="#fff"/><path d="M15.27,23.707c0.389,0.385,1.04,0.389,1.429,0l6.999-6.9c0.395-0.391,0.394-1.024,0-1.414   c-0.394-0.391-1.034-0.391-1.428,0l-5.275,5.2V1c0-0.552-0.452-1-1.01-1c-0.558,0-1.01,0.448-1.01,1v19.593l-5.275-5.2   c-0.395-0.391-1.034-0.391-1.428,0c-0.395,0.391-0.395,1.024,0,1.414L15.27,23.707z" fill="#fff"/></g><g/><g/><g/><g/><g/><g/></svg>Your guide</a>
      <router-link to="/browse-grapevines" class="pure-button visible-mobile" id="browse-grapevines-button">Browse</router-link>

      <div class="guide-wrap hidden">
        <a class="pure-button" href="#" v-on:click.stop.prevent="howToGrapevine()">Your guide to grapevine</a>
      </div>

      <h3 class="browse-grapevines-heading hidden-mobile">Top grapevines <a href="#" class="refresh-grapevines" v-on:click.stop.prevent="refreshTopGrapevines()" v-if="!isPress"><i class="fal fa-sync"></i></a></h3>

      <div id="browse-grapvines-wrap" class="hidden-mobile">
        <ul id="browse-grapevines" class="pure-g" v-images-loaded:on.progress="grapevineImageLoaded">
          <li v-for="grapevine in grapevines" class="big-grapevine-item pure-u-1-5" :data-id="grapevine.id">
            <router-link class="list-link" v-on:click.native="viewGrapevine()" v-bind:to="{ name: 'grapevine', params: { id: grapevine.id, name: encodeURIComponent(grapevine.name) } }"><div class="img-wrap"><span class="grapes-count">{{grapevine.count}}</span><span class="grapes-count-bg"></span><img class="grape-img" :src="grapevine.grapeImage" v-if="grapevine.grapeImage" /></div><div class="grapevine-details-wrap"><span class="grapevine-name">{{ grapevine.name }}</span></div></router-link>
          </li>
        </ul>
        <router-link :to="browseGrapevinesLink" class="pure-button browse-grapevines-view-all hidden-mobile">Browse grapevines</router-link>
      </div>

      <div id="grape-tabs">
         <a class="pure-button change-grapes-random active" href="#" v-on:click.stop.prevent="changeGrapes('random')"><svg enable-background="new 0 0 144.083 144" version="1.1" viewBox="0 0 144.083 144" width="144.083px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M105.793,66.041c0-6.709-5.459-12.167-12.168-12.167c-4.725,0-8.818,2.712-10.832,6.655  c-1.656-3.239-4.711-5.648-8.371-6.404c-0.135-1.278-0.727-8.613,3.012-12.896c1.846-2.115,4.547-3.188,8.025-3.188v-3  c-4.389,0-7.854,1.422-10.295,4.226c-0.484,0.556-0.893,1.152-1.266,1.765c-0.746-3.521-2.378-7.913-5.968-10.595v0.001  c-6.592-4.928-16.864-1.894-17.298-1.762l-1.056,0.32l-0.008,1.104c-0.003,0.453-0.005,11.165,6.59,16.091  c2.926,2.188,6.577,2.807,9.771,2.807c2.207,0,4.192-0.295,5.573-0.573c-0.286,2.358-0.204,4.39-0.114,5.479  c-4.48,0.21-8.328,2.844-10.261,6.626c-2.015-3.943-6.109-6.655-10.833-6.655c-6.709,0-12.167,5.458-12.167,12.167  s5.458,12.167,12.167,12.167c0.684,0,1.35-0.07,2.003-0.18c-2.063,2.182-3.337,5.114-3.337,8.346  c0,6.709,5.458,12.167,12.167,12.167c0.623,0,1.229-0.062,1.828-0.152c-1.958,2.16-3.162,5.015-3.162,8.152  c0,6.709,5.458,12.167,12.167,12.167c6.708,0,12.167-5.458,12.167-12.167c0-3.138-1.205-5.992-3.162-8.152  c0.598,0.091,1.205,0.152,1.828,0.152c6.709,0,12.166-5.458,12.166-12.167c0-3.231-1.273-6.164-3.336-8.346  c0.652,0.109,1.318,0.18,2.002,0.18C100.334,78.208,105.793,72.75,105.793,66.041z M57.954,43.788  c-4.259-3.181-5.15-9.846-5.336-12.521c2.614-0.582,9.246-1.618,13.518,1.573l0,0.001c4.26,3.182,5.15,9.847,5.337,12.521  C68.857,45.945,62.227,46.982,57.954,43.788z M84.795,74.387c-0.652-0.109-1.318-0.18-2.002-0.18s-1.35,0.07-2.004,0.18  c0.797-0.842,1.473-1.794,2.004-2.834C83.325,72.593,84,73.545,84.795,74.387z M71.96,56.874c5.054,0,9.167,4.112,9.167,9.167  s-4.113,9.167-9.167,9.167c-5.055,0-9.167-4.112-9.167-9.167S66.905,56.874,71.96,56.874z M69.957,78.028  c0.653,0.109,1.319,0.18,2.003,0.18c0.683,0,1.349-0.07,2.003-0.18c-0.797,0.842-1.472,1.794-2.003,2.834  C71.429,79.822,70.753,78.87,69.957,78.028z M73.788,94.526c-0.598-0.091-1.205-0.152-1.828-0.152c-0.623,0-1.229,0.062-1.827,0.152  c0.719-0.794,1.335-1.679,1.827-2.641C72.452,92.848,73.069,93.732,73.788,94.526z M63.13,74.387  c-0.653-0.109-1.319-0.18-2.003-0.18s-1.35,0.07-2.003,0.18c0.796-0.842,1.471-1.794,2.003-2.834  C61.659,72.593,62.334,73.545,63.13,74.387z M50.294,75.208c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S55.349,75.208,50.294,75.208z M61.127,95.541c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S66.182,95.541,61.127,95.541z M81.127,106.541c0,5.055-4.113,9.167-9.167,9.167  c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167C77.014,97.374,81.127,101.486,81.127,106.541z M91.959,86.374  c0,5.055-4.111,9.167-9.166,9.167s-9.168-4.112-9.168-9.167s4.113-9.167,9.168-9.167S91.959,81.319,91.959,86.374z M84.459,66.041  c0-5.055,4.111-9.167,9.166-9.167s9.168,4.112,9.168,9.167s-4.113,9.167-9.168,9.167S84.459,71.096,84.459,66.041z" fill="#fff" /></svg> Lucky dip</a>
         <a class="pure-button change-grapes-latest" href="#" v-on:click.stop.prevent="changeGrapes('latest')"><i class="fal fa-bolt"></i> New</a>
         <a class="pure-button change-grapes-top-rated" href="#" v-on:click.stop.prevent="changeGrapes('top-rated')"><i class="fal fa-bookmark"></i> Top rated</a>
      </div>

      <div id="home-grapes" v-images-loaded:on.progress="grapeImageLoaded" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="1000">
        <div class="grapes-loading" v-if="grapesLoading">
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

    </div>
  </section>

</template>

<script>
  /* global $, algoliasearch */
  import Grape from './Grape.vue'
  import db from './firebaseInit'
  import imagesLoaded from 'vue-images-loaded'
  const crypto = require('crypto');

  export default {
    name: 'home',
    metaInfo: {
      title: 'Grapevine',
      // override the parent template and just use the above title only
      titleTemplate: null
    },
    directives: {
      imagesLoaded,
    },
    data () {
      return {
        currentUserID: null,
        isLoggedIn: false,
        grapes: [],
        grapes2: [],
        grapevineName: null,
        isLoading: false,
        search: '',
        lastVisible: null,
        enableLoadMore: false,
        firstLoad: 5,
        pageLimit: 20,
        howToGrapevineActivated: false,
        grapevineUserID: 'QxBYvA9ipPef5cOLYZKhdDv0rb03',
        grapevines: [],
        grapevineLimit: 10,
        grapevinePullLimit: 14,
        currentType: 'random',
        topGrapeIDs: [],
        randomGrapevinesLoaded: false,
        loadCheckCount: 0,
        loadGrapesInterval: null,
        loadingHideTime: 1000,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        grapeRatingsDatabase: this.$globals.grapeRatingsDatabase,
        addGrapeLink: '/add',
        browseGrapevinesLink: '/browse-grapevines',
        isPress: this.$globals.isPress,
        grapesLoading: false
      }
    },
    created () {

      this.showLoading()

      if (this.isPress) {
        // this.addGrapeLink = '/print/add'
        // this.browseGrapevinesLink = '/print/browse-grapevines'
        this.getRandomGrapes()
        this.getGrapevines()
      } else {
        // this.getGrapes()
        // this.getGrapevines()
        if ($(window).width() > 767) {
          this.loadGrapesInterval = setInterval(this.checkToLoadGrapes, 100)
          this.getRandomGrapevines()        
        } else {
          this.firstLoad = 3
          this.pageLimit = 5
          this.loadingHideTime = 5000
          // this.hideLoading()
          this.getRandomGrapes()
        }
      }

      //this.getRandomGrapes()
    },
    methods: {
      checkToLoadGrapes() {
        this.loadCheckCount++
        if (this.randomGrapevinesLoaded || this.loadCheckCount > 50) {
          this.hideLoading()
          this.getRandomGrapes()
          clearInterval(this.loadGrapesInterval)
        } else {
          console.log('waiting to load grapes')
        }
      },
      showLoading () {
        let vm = this
        if (vm.$globals.siteHasLoaded) {
          $('#home-loading-overlay').remove()
        }
        $('html').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        let vm = this
        $('html').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
        setTimeout(function () {
          vm.$globals.siteHasLoaded = true
          $('#home-loading-overlay').fadeOut(500)
        }, 1000)
      },
      howToGrapevine () {
        this.howToGrapevineActivated = true
      },
      howToGrapevineClose () {
        this.howToGrapevineActivated = false
      },
      modalTabSwitch: function (id) {
        console.log(id)
        $('.how-to-grapevine-wrap').find('.tab').css('display', 'none')
        $('.how-to-grapevine-wrap').find('.tabs-select > a').removeClass('active')
        $('.how-to-grapevine-wrap').find('.tab[data-tab="' + id + '"]').css('display', 'block')
        $('.how-to-grapevine-wrap').find('.tabs-select a[data-id="' + id + '"]').addClass('active')
      },
      getGrapes: function () {
        var vm = this
        var grapesRef = db.collection(vm.grapesDatabase).orderBy('updatedTimestamp', 'desc').limit(vm.pageLimit)
        grapesRef.get().then((querySnapshot) => {
          this.isLoading = true
          console.log('created query: ' + querySnapshot.docs.length)
          this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
          })
          vm.hideLoading()
          setTimeout(function () {
            vm.isLoading = false
          }, 1000)
        })
      },
      getTopRatedGrapes: function () {
        console.log('getTopRatedGrapes')
        var vm = this
        vm.topGrapeIDs = []
        var grapesRef = db.collection(vm.grapeRatingsDatabase).where('userID', '==', vm.grapevineUserID).where('rating', '==', '5').orderBy('createdTimestamp', 'desc').limit(100)
        grapesRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              vm.topGrapeIDs.push(doc.data().grapeID)
            }
          })
          if (vm.topGrapeIDs.length > 0) {
            vm.topGrapeIDs.forEach(grapeID => {
              db.collection(vm.grapesDatabase).where('id', '==', grapeID).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  var grapeData = doc.data()
                  grapeData.docID = doc.id
                  if (!vm.checkGrapePresent(vm.grapes, grapeData.id, true)) {
                    vm.grapes.push(grapeData)
                  }
                })
                vm.hideLoading()
                setTimeout(function () {
                  vm.isLoading = false
                }, 1000)
              })
            })
          } else {
            vm.hideLoading()
            setTimeout(function () {
              vm.isLoading = false
            }, vm.loadingHideTime)
          }
        })
      },
      getRandomGrapes: function () {
        let vm = this
        console.log('getRandomGrapes from database: ' + vm.grapesDatabase)
        var limit = vm.pageLimit
        if (vm.grapes.length === 0) {
          limit = vm.firstLoad
        }
        for (var i = 0; i < limit; i++) {
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          let grapesRef = db.collection(vm.grapesDatabase)
          var queryRef = grapesRef.where('random', '>', random).orderBy('random').limit(1)
          queryRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists && !vm.checkGrapePresent(vm.grapes, doc.data().id, true)) {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                if (!vm.checkGrapePresent(vm.grapes, grapeData.id, true)) {
                  vm.grapes.push(grapeData)
                }
              } else {
                queryRef = grapesRef.where('random', '<=', random).orderBy('random', 'desc').limit(1)
                queryRef.get().then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                      var grapeData = doc.data()
                      grapeData.docID = doc.id
                      if (!vm.checkGrapePresent(vm.grapes, grapeData.id, true)) {
                        vm.grapes.push(grapeData)
                      }
                    }
                  })
                })
              }
            })
          })
          if (i + 1 === limit) {
            console.log('finished getRandomGrapes')
            vm.enableLoadMore = true
            vm.loadMore()
            setTimeout(function () {
              vm.isLoading = false
            }, vm.loadingHideTime+1000)
          }
        }
      },
      changeGrapes: function (type) {
        this.isLoading = true
        // this.showLoading()
        this.grapes = []
        this.grapesLoading = true
        $('#grape-tabs > a').removeClass('active')
        if (type === 'random') {
          this.currentType = 'random'
          $('#grape-tabs > a.change-grapes-random').addClass('active')
          this.getRandomGrapes()
        } else if (type === 'latest') {
          this.currentType = 'latest'
          $('#grape-tabs > a.change-grapes-latest').addClass('active')
          this.getGrapes()
        } else if (type === 'top-rated') {
          this.currentType = 'top-rated'
          $('#grape-tabs > a.change-grapes-top-rated').addClass('active')
          this.getTopRatedGrapes()
        }
      },
      checkGrapePresent: function (inArr, grapeID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapeID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      loadMore: function () {
        console.log('load more triggered')
        if (this.currentType === 'random') {
          if (!this.isLoading && this.enableLoadMore) {
            console.log('load more running')
            this.isLoading = true
            this.getRandomGrapes()
          }
        } else {
          var vm = this
          if (this.lastVisible && !this.isLoading && this.enableLoadMore) {
            console.log('load more running')
            this.isLoading = true
            var grapesRef = db.collection(vm.grapesDatabase).orderBy('updatedTimestamp', 'desc').startAfter(this.lastVisible).limit(vm.pageLimit)
            grapesRef.get().then((querySnapshot) => {
              this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
              console.log('load more activated, last visible: ' + this.lastVisible.data().id)
              querySnapshot.forEach((doc) => {
                if (doc.exists) {
                  var grapeData = doc.data()
                  grapeData.docID = doc.id
                  this.grapes.push(grapeData)
                }
              })
            })
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          }
        }
      },
      getGrapevines: function () {
        var vm = this
        vm.grapevines = []

        // Created Public
        var queryRef = db.collection(vm.grapevinesDatabase).where('userID', '==', vm.grapevineUserID).orderBy('grapeCount', 'desc').limit(10)
        if (vm.isPress) {
          queryRef = db.collection(vm.grapevinesDatabase).orderBy('createdTimestamp', 'asc').limit(10)
        }
        queryRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log('fetch: ' + doc.id, ' => ', doc.data())
            let data = doc.data()
            console.log(data)
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              grapes: data.grapes,
              grapeImage: null,
              count: data.grapes.length,
              isPrivate: data.privacy === 'private',
              created: data.createdTimestamp
            }
            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          })
        })

        this.$eventHub.$emit('external-trigger-grapevine')
      },
      getRandomGrapevines: function () {
        let vm = this
        console.log('getRandomGrapevines')
        for (var i = 0; i < vm.grapevinePullLimit; i++) {
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          let grapevinesRef = db.collection(vm.grapevinesDatabase)
          var queryRef = grapevinesRef.where('userID', '==', vm.grapevineUserID).where('random', '>', random).orderBy('random').limit(1)
          if (vm.isPress) {
            queryRef = grapevinesRef.where('random', '>', random).orderBy('random').limit(1)
          }
          queryRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists && !vm.checkGrapevinePresent(vm.grapevines, doc.data().id, true)) {
                var data = doc.data()
                var grapevineData = {
                  name: data.name.substr(0,1).toUpperCase() + data.name.substr(1),
                  id: doc.id,
                  isReadOnly: false,
                  grapes: data.grapes,
                  grapeImage: null,
                  count: data.grapes.length,
                  isPrivate: data.privacy === 'private',
                  created: data.createdTimestamp
                }
                if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true) && grapevineData.count > 0 && vm.grapevines.length <= vm.grapevineLimit) {
                  vm.getGrapevineImage(grapevineData)
                }
              } else {
                queryRef = grapevinesRef.where('userID', '==', vm.grapevineUserID).where('random', '<=', random).orderBy('random', 'desc').limit(1)
                if (vm.isPress) {
                  queryRef = grapevinesRef.where('random', '<=', random).orderBy('random', 'desc').limit(1)
                }
                queryRef.get().then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                      var data = doc.data()
                      var grapevineData = {
                        name: data.name,
                        id: doc.id,
                        isReadOnly: false,
                        grapes: data.grapes,
                        grapeImage: null,
                        count: data.grapes.length,
                        isPrivate: data.privacy === 'private',
                        created: data.createdTimestamp
                      }
                      if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true) && grapevineData.count > 0 && vm.grapevines.length <= vm.grapevineLimit) {
                        vm.getGrapevineImage(grapevineData)
                      }
                    }
                  })
                })
              }
            })
          })
          if (i + 1 === vm.grapevineLimit) {
            console.log('finished getRandomGrapevines')
          }
        }
      },
      refreshTopGrapevines: function () {
        $('#browse-grapevines').css('min-height', $('#browse-grapevines').outerHeight(true))
        this.grapevines = []
        this.getRandomGrapevines()
      },
      checkGrapevinePresent: function (inArr, grapevineID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapevineID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      grapevinesSort: function () {
        let vm = this
        vm.grapevines.sort(function (a, b) {
          var countA = a.count ? parseInt(a.count) : 0
          var countB = b.count ? parseInt(b.count) : 0
          return countB - countA
        })
      },
      getGrapevineImage: function (grapevine) {
        let vm = this
        if (grapevine.grapes && grapevine.grapes.length > 0 && !grapevine.image) {
          db.collection(vm.grapesDatabase).where('id', '==', grapevine.grapes[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapevine.grapeImage = grapeData.sourceImage
              if (vm.isPress) {
                if (!grapeData.sourceImage) {
                  grapevine.grapeImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                }
              }
              if (!vm.checkGrapevinePresent(vm.grapevines, grapevine.id, true) && grapevine.grapeImage && (vm.grapevines.length < vm.grapevineLimit)) {
                vm.grapevines.push(grapevine)
              } else if (vm.grapevines.length >= vm.grapevineLimit) {
                // vm.randomGrapevinesLoaded = true
              }
              // vm.grapevinesSort()
            })
          })
        } else {
          vm.grapevines.push(grapevine)
          // vm.grapevinesSort()
        }
      },
      grapevineImageLoaded(instance, image) {
        let vm = this
        const result = image.isLoaded ? 'loaded' : 'broken';
        var i = $(image.img).parents('.big-grapevine-item').index()
        if (i > 0) {
          setTimeout(function() {
            vm.randomGrapevinesLoaded = true
          }, 400);
        }
        $(image.img).parents('.big-grapevine-item').transition({
          opacity: 1,
          delay: i*100,
          duration: 800,
          complete: function () {
            $(image.img).parents('.big-grapevine-item').addClass('item-animated');
          }
        });
      },
      grapeImageLoaded(instance, image) {
        let vm = this
        vm.grapesLoading = false
        setTimeout(function () {
          vm.hideLoading()
        }, 500)
      },
      viewGrapevine: function () {
        this.$eventHub.$emit('external-trigger-grapevine')
      },
    },
    mounted: function () {
    },
    components: {
      Grape
    }
  };
</script>

<style>
/*  .grape-wrap {
    opacity: 0;
  }
  .grape-wrap.item-animated {
    opacity: 1;
  }*/
</style>
<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 49.95%;
    margin: -5px auto 35px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    padding: 14px 20px;
    float: left;
    text-align: center;
  }
  #add-grape-button > svg {
    margin-right: 10px;
    width: 14px;
    height: 14px;
    vertical-align: -1px;
  }
  #browse-grapevines-button {
    width: 49.95%;
    float: right;
    margin: -5px auto 35px;
    background: #44873C;
    color: #fff;
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    padding: 14px 20px;
    text-align: center;
  }
  #browse-grapevines-button > svg {
    margin-right: 10px;
    width: 14px;
    height: 14px;
    vertical-align: -1px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 15px;
    padding: 6px 0 10px;
    clear: both;
    min-height: 1000px;
    position: relative;
  }
  .load-more-button {
    cursor: pointer;
  }
  .guide-wrap > a {
    width: 100%;
    text-transform: uppercase;
    color: #36a731;
    background: transparent;
    border: 1px solid #eaeaea;
    padding: 15px;
    font-size: 1.2em;
    font-weight: 400;
    box-shadow: 1px 1px 4px -2px rgba(0,0,0,0.5);
  }
  .grapes-loading {
    position: absolute;
    top: 0;
    width: 100%;
  }
  @media only screen and (max-width: 767px) {
    #home-grapes {
      margin-top: 0;
      padding: 0;
    }
    #add-grape-button, #browse-grapevines-button {
      width: 49.8%;
    }
  }
  .how-to-grapevine-wrap {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    overflow-y: scroll;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .how-to-grapevine-wrap > .container {
    width: 1000px;
    max-width: 80%;
    height: 90vh;
    background: #fff;
    margin: 0 auto;
    padding: 80px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    overflow-y: scroll;
  }
  .how-to-grapevine-wrap .modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    font-size: 32px;
    color: #222;
  }
  .how-to-grapevine-wrap .modal-close:hover {
    opacity: 0.6;
  }
  .how-to-grapevine-wrap .title-wrap {
    height: auto;
    overflow: hidden;
    margin: 0 0 40px;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 20px;
  }
  .how-to-grapevine-wrap .title-wrap h2 {
    float: left;
    margin: 0;
    color: #36a731;
    line-height: 40px;
  }
  .how-to-grapevine-wrap .title-wrap .tabs-select {
    float: right;
  }
  .how-to-grapevine-wrap .title-wrap .tabs-select > a {
    text-decoration: none;
    border: 1px solid #eaeaea;
    padding: 10px 20px;
    margin-left: 10px;
    display: inline-block;
    color: #36a731;
  }
  .how-to-grapevine-wrap .title-wrap .tabs-select > a.active {
    background-color: #36a731;
    color: #fff;
  }
  .how-to-grapevine-wrap .tab-wrap {
    padding: 0;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab {
    display: none;
    text-align: left;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab[data-tab="video"] {
    display: block;
    padding-left: 100px;
    padding-right: 100px;
    font-size: 17px;
    line-height: 1.5;
    padding-top: 5px;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab .video-wrap {
    margin: 40px 0;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab .divide {
    margin: 50px auto;
    width: 75%;
    height: 1px;
    background-color: #eaeaea;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab p {
    color: #176B0E;
  }
  .how-to-grapevine-wrap .tab-wrap > .tab p a {
    color: #36a731;  
  }
  .how-to-grapevine-wrap .tab img {
    width: 100%;
  }
  .tabs-select > a {
    text-transform: uppercase;
  }
  #main-col > h3.browse-grapevines-heading {
    text-align: left;
    text-transform: none;
    clear: both;
    margin-top: 0;
    font-size: 17px;
    margin-bottom: 10px;
    color: #353535;
  }
  h3.browse-grapevines-heading > a.refresh-grapevines {
    margin-left: 10px;
    vertical-align: -2px;
    color: #485057;
  }
  #browse-grapevines {
    padding: 40px 20px 0;
    margin: 0;
    border-top: 1px solid #eaeaea;
    box-sizing: border-box;
    min-height: 600px;
  }
  .browse-grapevines-view-all {
    width: 50%;
    color: #36a731;
    background: transparent;
    border: 1px solid #eaeaea;
    padding: 15px;
    font-size: 1.1em;
    font-weight: 400;
    box-shadow: 1px 1px 4px -2px rgba(0,0,0,0.5);
    margin: 0 auto 25px;
  }
  .big-grapevine-item {
    padding: 0 10px;
    margin-bottom: 30px;
    text-align: left;
    box-sizing: border-box;
    opacity: 0;
  }
  .big-grapevine-item.item-animated {
    opacity: 1;
  }
  .big-grapevine-item a {
    text-decoration: none;
    display: block;
  }
  .big-grapevine-item .img-wrap {
    position: relative;
    margin-bottom: 15px;
    display: inline-block;
    overflow: hidden;
  }
  .big-grapevine-item .img-wrap .grapes-count {
    position: absolute;
    bottom: 2px;
    right: 3px;
    z-index: 3;
    font-size: 14px;
    color: #169a16;
    font-weight: bold;
    width: 14px;
    text-align: center;
    display: inline-block;
  }
/*  .big-grapevine-item .img-wrap .grapes-count {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 3;
    font-size: 13px;
    background: #169a16;
    font-weight: 100;
    width: 22px;
    text-align: center;
    display: inline-block;
    color: #fff;
    border-radius: 50%;
    height: 22px;
    line-height: 22px;
  }*/
  .big-grapevine-item .img-wrap .grapes-count-bg {
    height: 64px;
    width: 64px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    display: block;
    position: absolute;
    background: #fff;
    z-index: 2;
    bottom: -32px;
    right: -32px;
  }
  .big-grapevine-item img {
    max-width: 100%;
    display: block;
    z-index: 1;
  }
  .big-grapevine-item:hover img {
    opacity: 0.6;
  }
  .big-grapevine-item .grapevine-details-wrap {
    max-width: 128px;
  }
  .big-grapevine-item .grapevine-name {
    margin-bottom: 12px;
    position: relative;
    display: inline;
    font-size: 1.1em;
    color: #169a16;
    padding-bottom: 2px;
  }
  .big-grapevine-item .grapevine-name:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 2px;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid rgba(22,154,22,0.25);
  }
  .big-grapevine-item .grapes-count {
    font-size: 0.8em;
    display: block;
    color: #6D6C6A;
    margin-top: 8px;
    display: none;
  }
  .big-grapevine-item .grapes-count svg {
    margin-left: -2px;
    display: none;
    width: 20px;
    height: 20px;
    vertical-align: -5px;
  }
  .big-grapevine-item:first-child .grapes-count svg {
    display: inline-block;
  }
  @media only screen and (max-width: 767px) {
    .big-grapevine-item {
      width: 33.3333%;
    }
    #add-grape-button {
      margin-top: 0;
      text-align: left;
      font-size: 14px;
      font-weight: 100;
      text-transform: uppercase;
      padding: 15px 20px;
    }
    #browse-grapevines-button {
      margin-top: 0;
      text-align: left;
      font-size: 14px;
      font-weight: 100;
      text-transform: uppercase;
      padding: 15px 20px;
    }
  }

  @media only screen and (max-width: 767px) {
    #browse-grapevines {
      margin: 0 -10px 0;
      padding: 0;
      border-top: 0;
    }
  }

  #grape-tabs {
    text-align: left;
    padding-top: 10px;
    font-size: 0;
  }
  #grape-tabs > a {
    width: 32%;
    color: #36a731;
    background: transparent;
    border: 1px solid #eaeaea;
    padding: 15px;
    font-size: 16px;
    font-weight: 400;
    margin: 0 0 10px;
    color: #777;
  }
  #grape-tabs > a.change-grapes-latest {
    margin: 0 2% 10px;
  }
  #grape-tabs > a i {
    vertical-align: -1px;
    margin-right: 6px;
  }
  #grape-tabs > a svg {
    width: 30px;
    height: 30px;
    vertical-align: -4px;
    margin: -5px 0;
  }
  #grape-tabs > a svg path {
    fill: #777;
  }
  #grape-tabs > a.active {
    background: #36a731;
    color: #fff;
  }
  #grape-tabs > a.active svg path {
    fill: #fff;
  }
  #grape-tabs > a:first-child {
    margin-left: 0;
  }

  @media only screen and (max-width: 767px) {
     #grape-tabs > a {
      width: 33%;
      text-align: right;
      padding: 8px 0;
      background: transparent;
      color: #aaa;
      border: 0;
    }
    #grape-tabs > a > i, #grape-tabs > a > svg {
      display: none;
    }
    #grape-tabs > a.active {
      background: transparent;
      color: #36a731;
    }
    #grape-tabs > a:first-child {
      text-align: left;
    }
    #grape-tabs > a.change-grapes-latest {
      margin: 0 0 10px;
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue